import { render, staticRenderFns } from "./configSelect.vue?vue&type=template&id=763ec210&scoped=true&"
import script from "./configSelect.vue?vue&type=script&lang=js&"
export * from "./configSelect.vue?vue&type=script&lang=js&"
import style0 from "./configSelect.vue?vue&type=style&index=0&id=763ec210&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763ec210",
  null
  
)

export default component.exports